export default "__VITE_ASSET__13b1e63e__"